var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { logout } from './reducers/authentication';
import auth from './lib/auth';
var token = function () { return auth.accessToken ? "Bearer ".concat(auth.accessToken) : ''; };
var handleAuthError = function (error) {
    if ([401, 403].includes(error.status)) {
        logout();
    }
    return Promise.reject(error);
};
// Wrapper for fetch that adds the authorization header and handles auth errors
var doFetch = function (url, init) {
    var defaults = {
        headers: {
            Accept: 'application/json',
            Authorization: token()
        }
    };
    return fetch(url, __assign(__assign({}, defaults), init))
        .then(function (res) { return res.ok ? res : Promise.reject(res); })
        .then(function (res) { return res.text(); })
        .then(function (text) { return text.length ? JSON.parse(text) : {}; })
        .catch(handleAuthError);
};
export var getOwnerParties = function () { return doFetch('/api/v1/products'); };
export var getMessages = function () { return doFetch('/api/v1/messages'); };
export var getEventTypes = function () { return doFetch('/api/v1/event/types'); };
export var getMessageStatuses = function (id) {
    return doFetch("/api/v1/messages/".concat(id, "/events"));
};
export var getTemplate = function (productKey, templateKey, templateVersion) {
    return doFetch("/api/v1/templates/".concat(productKey, "/").concat(templateKey, "/").concat(templateVersion));
};
export var getTemplates = function (latest) {
    if (latest === void 0) { latest = true; }
    return doFetch("/api/v1/templates?latest=".concat(latest));
};
export var getTemplateFormats = function () { return doFetch('/api/v1/template-formats'); };
export var searchMessages = function (filter) {
    return doFetch('/api/v1/messages/search', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token()
        },
        body: JSON.stringify(filter)
    });
};
export var saveTemplate = function (productKey, templateKey, editTemplateDTO) {
    return doFetch("/api/v1/templates/".concat(productKey, "/").concat(templateKey), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token()
        },
        body: JSON.stringify(editTemplateDTO)
    });
};
export var createTemplate = function (createTemplateDTO) {
    return doFetch('/api/v1/templates', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token()
        },
        body: JSON.stringify(createTemplateDTO)
    });
};
export var getCurrentUser = function () { return doFetch('/api/v1/user/details'); };
export var getSubUsers = function () { return doFetch('/api/v1/subusers'); };
export var getSubUser = function (username) {
    return doFetch("/api/v1/subusers/".concat(username));
};
export var editSubUser = function (request) {
    return doFetch('/api/v1/subusers', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token()
        },
        body: JSON.stringify(request)
    });
};
export var createSubUser = function (request) {
    return doFetch('/api/v1/subusers', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token()
        },
        body: JSON.stringify(request)
    });
};
export var deleteSubUser = function (username) {
    return doFetch("/api/v1/subusers/".concat(username), {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token()
        }
    });
};
